import { ViewStyle } from 'react-native';

const container: ViewStyle = {
    position: 'relative',
    justifyContent: 'center',
    alignItems: 'center'
};
const defaultRing: ViewStyle = {
    position: 'absolute',
    width: 18,
    height: 18,
    backgroundColor: '#fff',
    borderRadius: 9
};

export default {
    container,
    defaultRing
};
